import React from 'react';
import FooterLinks from './FooterLinks';
import SocialLinks from './SocialLinks';

const FooterTop: React.FC = () => {
  return (
    <div className="relative mx-auto w-full max-w-[1400px] px-4 py-5 sm:px-6 lg:px-8 lg:py-6">
      <div className="rounded-2xl border border-white/10 bg-slate-950/70 px-4 py-5 shadow-[0_18px_48px_rgba(0,0,0,0.24)] backdrop-blur-xl sm:px-6 sm:py-6 lg:px-8">
        <div className="grid w-full gap-6 lg:grid-cols-[minmax(260px,0.78fr)_minmax(0,2.22fr)] lg:items-start">
          <div className="min-w-0">
            <div className="flex min-w-0 items-center gap-4">
              <img
                src="/assets/images/logo/NEXLogo.png"
                alt="Nex Computer"
                className="h-10 w-10 shrink-0 object-contain"
              />
              <div className="min-w-0">
                <p className="truncate text-base font-bold text-white">Nex Computer</p>
                <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-indigo-300">Solution via Dedication</p>
              </div>
            </div>

            <p className="mt-4 max-w-sm text-[clamp(0.8125rem,1.5vw,0.9rem)] leading-6 text-slate-400">
              Nex Computer brings premium devices, custom builds, and trusted tech advice to Sri Lanka.
              Shop with confidence and get trusted support for the right setup.
            </p>

            <div className="mt-5 flex flex-wrap items-center gap-3">
              <SocialLinks />
              <div className="hidden h-7 w-px bg-white/10 sm:block" />
              <div className="flex flex-wrap gap-2.5 text-[11px] text-slate-400">
                <span className="rounded-md border border-white/10 bg-white/[0.03] px-2 py-1">Retail, repairs, upgrades</span>
                <span className="rounded-md border border-white/10 bg-white/[0.03] px-2 py-1">Islandwide customer care</span>
              </div>
            </div>
          </div>

          <FooterLinks />
        </div>
      </div>
    </div>
  );
};

export default FooterTop;
